/*
*
* Add all your project HTML markups here
*
* */

import {formatMoney} from "./service.cart";

export const captchaMarkup = (captchaContainer, siteKey) => {
    return `var onCaptchaSuccessCustom = function () {
                var event;
                try {
                    event = new Event('captchaSuccessCustom', {bubbles: true, cancelable: true});
                } catch (e) {
                    event = document.createEvent('Event');
                    event.initEvent('captchaSuccessCustom', true, true);
                }
                window.dispatchEvent(event);
            }
            
            var recaptchaCallbackCustom = function () {
                let widgetId = grecaptcha.render('${captchaContainer}', {
                    sitekey: ${siteKey},
                    size: (window.innerWidth > 320) ? 'normal' : 'compact',
                    callback: 'onCaptchaSuccessCustom',
                })
            ;};
            `
};

export const modalQuickViewHtml = () => {
    return `<div class="modal">
                <div class="content">
                    <div class="header">
                        <button class="btn--close close-modal">Close</button>
                    </div>
                    <div class="row">
                        <div class="col col-sm-6 col-md-5 col-lg-8" id="slider"></div>
                        <div class="col col-sm-6 col-md-4 col-lg-4" id="toolbar"></div>
                        <div id="product-custom-data"></div>
                        <div id="set-products"></div>
                    </div>
                </div>
           </div>`;
}

